import { Component, EventEmitter, OnInit, Output, ElementRef, ViewChild } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-account-documents',
  templateUrl: './account-documents.component.html',
  styleUrls: ['./account-documents.component.css'],
  standalone: false
})
export class AccountDocumentsComponent implements OnInit {
  @Output()
  accountDocuments = new EventEmitter<any>();

  WIDTH = 640;
  HEIGHT = 480;

  // @ts-ignore
  @ViewChild('video')
  public video: ElementRef;

  // @ts-ignore
  @ViewChild('canvas')
  public canvas: ElementRef;

  environment = environment;
  identityFrontFile: File|null;
  identityBackFile: File|null;
  submitted: boolean;
  selfieCapture: {
    baseUrl: string|null;
    file: File|Blob|null;
  };
  displayCanvas: boolean;
  acceptCgv: boolean;
  acceptActuality: boolean;
  isMobileDevice: boolean;
  captureSelfieType: string;
  error: null;
  constructor(private deviceService: DeviceDetectorService) { }

  ngOnInit() {
    this.isMobileDevice = this.deviceService.isMobile();
    this.identityFrontFile = null;
    this.identityBackFile = null;
    this.displayCanvas = false;
    this.submitted = false;
    this.acceptCgv = false;
    this.acceptActuality = false;
    this.selfieCapture = {
      baseUrl: null,
      file: null,
    };
    this.captureSelfieType = 'uploadSelfie';
  }

  getFile($event, fileType: string) {
    if (fileType === environment.data.identityFrontFileTypeSlug) {
      this.identityFrontFile = $event.target.files[0];
    } else if (fileType === environment.data.identityBackFileTypeSlug){
      this.identityBackFile = $event.target.files[0];
    } else {
      this.selfieCapture.file =  $event.target.files[0];
    }
  }

  deleteFile(fileType: string) {
    if (fileType === environment.data.identityFrontFileTypeSlug) {
      this.identityFrontFile = null;
    } else  if (fileType === environment.data.identityBackFileTypeSlug){
      this.identityBackFile = null;
    } else {
      this.selfieCapture = {
        baseUrl: null,
        file: null,
      };
    }
  }

  takeNewPicture() {
    this.selfieCapture = {
      baseUrl: null,
      file: null,
    };
    this.setupDevices(true);
  }

  async setupDevices(open: boolean) {
    this.displayCanvas = open;
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      try {
        if (open) {
          this.video.nativeElement.srcObject = await navigator.mediaDevices.getUserMedia({
            video: open
          });
          this.video.nativeElement.play();
        } else {
          const tracks = this.video.nativeElement.srcObject.getTracks();
          tracks.forEach((track) => {
            // stopping every track
            track.stop();
          });
          this.video.nativeElement = null;
        }
        this.error = null;
      } catch (e) {
        this.error = e;
      }
    }
  }

  drawImageToCanvas(image: any) {
    this.canvas.nativeElement
        .getContext('2d')
        .drawImage(image, 0, 0, this.WIDTH, this.HEIGHT);
  }

  private base64ToBlob(base64Img: string) {
    const base = base64Img.replace('data:image/png;base64,', '');
    const byteCharacters = atob(base);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], {type: 'image/png'});
  }

  async capture(fileType: string) {
    if (this.video.nativeElement.srcObject && this.selfieCapture.file == null) {
      this.drawImageToCanvas(this.video.nativeElement);
      const base64Img = this.canvas.nativeElement.toDataURL('image/png');
      this.selfieCapture = {
        baseUrl: base64Img,
        file: this.base64ToBlob(base64Img)
      };
      this.setupDevices(false);
    }
  }

  scrollToHandler(target: string) {
    document.getElementById(target).scrollIntoView({ behavior: 'smooth' });
  }

  setCheckbox(type: string, $event: any) {
    if (type === 'cgv') {
      this.acceptCgv = $event.target.checked;
    } else {
      this.acceptActuality = $event.target.checked;
    }
  }

  setSelfieTypeValue(selfieType: string) {
    this.captureSelfieType = selfieType;
    this.selfieCapture = {
      baseUrl: null,
      file: null,
    };
  }

  save() {
    this.accountDocuments.emit({
      identityFrontFile: this.identityFrontFile,
      identityBackFile: this.identityBackFile,
      selfieCapture: this.selfieCapture.file,
      acceptCgv: this.acceptCgv,
      acceptActuality: this.acceptActuality
    });
  }

  getSelfieCaptureFileName() {
    if (this.selfieCapture.file instanceof File) {
      return this.selfieCapture.file.name;
    } else {
      return '';
    }
  }
}
